import styled, { css } from "styled-components";
import media from "constants/media";
import Input from "components/shared/input/Input";

export const InputAddress = styled(Input)`
    ${({ suggestionIsOpen }) =>
        suggestionIsOpen &&
        css`
            border-color: var(--color-lightNight);
        `}
`;

export const AddressInputWrapper = styled.div`
    position: relative;
`;

export const IconSearchWrapper = styled.div`
    width: 16px;
    height: 16px;

    opacity: ${({ fieldActive }) => (fieldActive ? "1" : "0.5")};
`;

export const Close = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;

    width: 12px;

    cursor: pointer;

    svg {
        width: 100%;
    }
`;

export const Title = styled.div`
    margin-bottom: 25px;

    font-size: 20px;
    line-height: 25px;

    ${media.mdUp`
        font-size: 24px;
        line-height: 30px;
    `}
`;

export const Controls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const LocationContainer = styled.div`
    position: absolute;
    right: 0;
    z-index: 4;
`;

export const Location = styled.span`
    display: flex;
    align-items: center;

    color: var(--color-peach);

    cursor: pointer;

    svg {
        width: 15px;
        height: 15px;

        margin-right: 5px;
    }
`;
